<div class="icon-wrapper">
  <span class="icon-warning--alt--filled text-danger me-2"></span>
  @if (offense?.penaltyIssued) {
    <span class="icon-currency--dollar" [ngClass]="{'price--line-through': (offense?.penaltyState == penaltyStateCancelled)}"></span>
  }
</div>
<div class="form-row row">
  <div class="form-group col-md-6">
    <label class="control-label">{{'i18n.domain.parker-registration.fields.offense' | translate}}</label>
    <div class="tooltip-finetune">
      <ejs-tooltip content="{{offense?.offenseLog}}">
        <div>{{getOffenseType(offense) | translate}}</div>
      </ejs-tooltip>
    </div>
  </div>
  @if (displayIssuerName) {
    <div class="form-group col-md-6">
      <label class="control-label">{{'i18n.domain.parker-registration.fields.issuer' | translate}}</label>
      <div>{{getRegisteredByText(offense)}}</div>
    </div>
  }
</div>
<div class="form-row row">
  <div class="form-group col-md-6">
    <label class="control-label">{{'i18n.domain.parker-registration.fields.penaltyNumber' | translate}}</label>
    <div>{{offense?.penaltyNumber ?? '-'}}</div>
  </div>
  <div class="form-group col-md-6">
    <label class="control-label">{{'i18n.domain.parker-registration.fields.penaltyParkingNumber' | translate}}</label>
    <div>{{offense?.penaltyParkingNumber ?? '-'}}</div>
  </div>
</div>

@if (offense.mediaFiles?.length) {
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label class="control-label">{{'i18n.domain.parker-registration.fields.media-gallery' | translate}}</label>
      <div class="d-flex align-items-center flex-wrap">
        @for (imageId of offense.mediaFiles; track imageId) {
          <app-async-image [request]="getImageRequest(offense.id, imageId)"></app-async-image>
        }
      </div>
    </div>
  </div>
}

@if (offense?.offenseLog) {
  <div class="form-row row">
    <div class="form-group col-12 mb-0">
      <label class="control-label">{{'i18n.domain.parker-registration.dialog.section-offense-log' | translate}}</label>
      <pre class="offense-log-console">{{ formatOffenseLog(offense.offenseLog) }}</pre>
    </div>
  </div>
}
